import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCrossCircleBox24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCrossCircleBox24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19 4.5H5A1.5 1.5 0 0 0 3.5 6v12A1.5 1.5 0 0 0 5 19.5h14a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 19 4.5M5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm7 13.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0 1.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12m2.03-8.03a.764.764 0 0 1-.008 1.069l-.961.961.977.978a.736.736 0 0 1-.008 1.052.764.764 0 0 1-1.069-.008L12 13.061l-.978.978a.736.736 0 0 1-1.052-.009.764.764 0 0 1 .008-1.069l.961-.961-.977-.978A.736.736 0 0 1 9.97 9.97a.764.764 0 0 1 1.069.008l.96.961.978-.977a.736.736 0 0 1 1.053.008"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCrossCircleBox24);
